// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ccfb65de","453":"566e3551","549":"98caa67e","773":"9b71c344"}[chunkId] + ".chunk.js";
};